export interface JwtToken {
    exp: number;
    p: string;
}

const safeAtob = (input: string): string => {
    if (typeof atob === 'function') {
        return atob(input);
    }

    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    const str = input.replace(/=+$/, '');
    let output = '';

    if (str.length % 4 === 1) {
        throw new Error('Invalid base64 string');
    }

    let bc = 0;
    let bs: number | undefined;
    let buffer: number | undefined;
    let idx = 0;

    while ((buffer = str.charAt(idx++) as unknown as number)) {
        // @ts-expect-error charAt returns string; chars.indexOf expects string
        buffer = chars.indexOf(buffer);
        if (buffer === -1) {
            continue;
        }

        bs = bc % 4 ? (bs as number) * 64 + buffer : buffer;
        if (bc++ % 4) {
            output += String.fromCharCode(255 & ((bs as number) >> ((-2 * bc) & 6)));
        }
    }

    return output;
};

export const decodeToken = (token: string): JwtToken | null => {
    const parts = token.split('.');
    if (parts.length !== 3) {
        return null;
    }
    try {
        const payloadBase64 = parts[1];
        const decodedPayload = safeAtob(payloadBase64);
        return JSON.parse(decodedPayload);
    } catch (err) {
        console.error(err);
        return null;
    }
};
